import { useParams } from "react-router";
import "./DaCreateAccountPage.css";
import { DaCreateAccount } from "../../components/DaCreateAccount/DaCreateAccount";

function DaCreateAccountPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaCreateAccount /> : null}
    </div>
  );
}

export default DaCreateAccountPage;
